import { useRemoteData } from "@sinch/mfe-helper-react";
import { useMemo } from "react";
import z from "zod";
import { useFetchUser } from "../../../api/hooks/useUser";
import { getMessageMediaApiUrl } from "../../../config/config";
import { WORKFLOWS_ABANDONED_CART } from "../featureList";

const INTEGRATIONS = ["bigcommerce", "shopify"] as const;
export type Integrations = (typeof INTEGRATIONS)[number];

const integrationZod = z.object({
  integration: z.string(),
  status: z.union([z.literal("INACTIVE"), z.literal("ACTIVE")]),
});

export type Integration = z.infer<typeof integrationZod>;

const MMFetchIntegrationURL = `${getMessageMediaApiUrl()}/int-bff/integrations/platform`;

export const useIntegration = (integration: Integrations) => {
  const [user] = useFetchUser();
  const hasIntegrationPermission = useMemo(
    () => user?.rights.includes(WORKFLOWS_ABANDONED_CART) || false,
    [user?.rights]
  );
  return useRemoteData(`${MMFetchIntegrationURL}/${integration}/status`, {
    useToken: true,
    enabled: hasIntegrationPermission,
    parse: (data) => {
      const parsed = integrationZod.safeParse(data);
      if (parsed.success) return parsed.data;
      const errorMessage =
        "Invalid response from integrations/platform/:platform/status";
      console.error(errorMessage, parsed.error);
      return data as Integration;
    },
  }).getState();
};
